import VELOCASH_EXT_1 from "./VELOCASH_EXT_1";
export default {
  VELOCASH_EXT_1,
};
